import { Text, VStack } from '@ayble-health/dashboard-components';
import { Image } from '@chakra-ui/react';

export const TasksEmptyState = () => (
  <VStack align="center" justify="center" py={10} gap={4} textAlign="center">
    <Image src="/no-tasks.png" alt="No tasks" maxW="200px" />
    <VStack gap={1}>
      <Text fontWeight={700} color="muted.600">
        Nice job – you have no more tasks today
      </Text>
      <Text fontSize="sm" color="muted.400">
        Go enjoy your day, and thanks for the hard work!
      </Text>
    </VStack>
  </VStack>
);
